import React, { FC } from 'react';
import { RichText } from '@graphcms/rich-text-react-renderer';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import useStore from '../../hooks/useStore';
import ContentStore from '../../stores/ContentStore';
import useIsMobileView from '../../hooks/useIsMobileView';
import { Typography } from './Typography';
import { ColorScheme } from '../colorScheme';

const ContentWrapper = styled.div<{ $isMobile: boolean }>`
  p {
    margin-bottom: 0.5em;
  }
`;

interface PageHeaderContentProps {
  cmsKey: string;
}

const PageHeaderContent: FC<PageHeaderContentProps> = (props) => {
  const { cmsKey } = props;
  const contentStore = useStore(ContentStore) as ContentStore;
  const content = contentStore.cmsStore.getContent(cmsKey);
  const richContent = content?.richContent?.raw;
  const isMobile = useIsMobileView();

  const hasContent = Boolean(content?.subText || richContent);

  return hasContent ? (
    <ContentWrapper $isMobile={isMobile}>
      {content?.subText && (
        <Typography variant="content" as="p" align="left">
          {content.subText}
        </Typography>
      )}
      {richContent && (
        <RichText
          content={richContent}
          renderers={{
            p: ({ children }) => (
              <Typography variant="content" as="p" align="left">
                {children}
              </Typography>
            ),
            a: ({ children, href }) => (
              <a target="_blank" href={href} rel="noopener noreferrer">
                <Typography
                  variant="contentLink"
                  as="span"
                  align="left"
                  color={ColorScheme.BrobizzGreen}
                >
                  {children}
                </Typography>
              </a>
            )
          }}
        />
      )}
    </ContentWrapper>
  ) : null;
};

export default observer(PageHeaderContent);
